import React, { useEffect } from 'react';
import '../styles/Laporan.css';

const Laporan = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="buat-laporan-container">
            <div className="form-container">
                <iframe
                    id="JotFormIFrame-243081782338056"
                    title="Formulir Pengaduan"
                    onLoad={() => window.parent.scrollTo(0, 0)}
                    allowTransparency="true"
                    allow="geolocation; microphone; camera; fullscreen"
                    src="https://form.jotform.com/243081782338056"
                    frameBorder="0"
                    style={{ minWidth: '100%', maxWidth: '100%', height: '700px', border: 'none', overflow: 'auto' }}
                    scrolling="yes"
                ></iframe>

            </div>
        </div>
    );
};

export default Laporan;
